import React, { useEffect } from 'react'
import Loader from 'view/component/loader'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { isLoggedIn } from 'action/auth'
import Login from 'view/page/login'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router'
import LoggedInRoutes from './logged-in-routes'

const Routes = ({ isAuthenticated, isLoggedIn, loginCheckComplete }) => {
  const location = useLocation()
  useEffect(() => {
    isLoggedIn(location)
  }, [])
  return (loginCheckComplete && isAuthenticated
    ? <LoggedInRoutes />
    : loginCheckComplete
      ? <Login />
      : <Loader />
  )
}

Routes.propTypes = {
  isAuthenticated: PropTypes.bool,
  isLoggedIn: PropTypes.func,
  loginCheckComplete: PropTypes.bool
}
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loginCheckComplete: state.auth.loginCheckComplete
})

const mapDispatchToProps = (dispatch) => ({
  isLoggedIn: bindActionCreators(isLoggedIn, dispatch)

})

export default connect(mapStateToProps, mapDispatchToProps)(Routes)
